module.exports = __webpack_public_path__ + "static/media/objects2_10.270484cc.svg";